"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgStarsAndBox = function SvgStarsAndBox(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 196 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E6F2FF",
    d: "M137.736 13.621h10.63v26.978h-10.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6F2FF",
    d: "M130.031 40.599h10.63v63.075h-10.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.166 41.194h-7.531V14h106.73v27.194h-7.531m-91.668 0v62.859h91.668V41.194m-91.668 0h91.668",
    stroke: "#C2C5CC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.94 29.526-5.877 3.09 1.123-6.544-4.756-4.636 6.572-.955 2.939-5.955 2.939 5.955 6.571.955-4.755 4.636 1.123 6.545-5.878-3.09zm169.295-6.441-8.653 4.441 1.653-9.407-7-6.662 9.674-1.372 4.326-8.559 4.326 8.559 9.674 1.372-7 6.662 1.652 9.407-8.652-4.441zM37.193 110.401l-4.018 2.05.768-4.341-3.25-3.075 4.491-.634 2.009-3.95 2.008 3.95 4.492.634-3.25 3.075.767 4.341-4.017-2.05z",
    fill: "#fff",
    stroke: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 63.026a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm24 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 54.026,
    width: 45,
    height: 15,
    rx: 7.5,
    stroke: "#C2C5CC",
    strokeDasharray: "2 2"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgStarsAndBox);
var _default = Memo;
exports["default"] = _default;